import Vue from 'vue'
import Router from 'vue-router'
import { buildTree,treeDataTranslate } from '@/utils'
import { isURL } from '@/utils/validate'
import { info }  from '../api/api';


Vue.use(Router);

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-development');

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
    { path: '/404', component: _import('common/404'), name: '404', meta: { title: '404未找到' } },
    { path: '/login', component:_import('login/index'), name: 'login', meta: { title: '登录' } }
];

// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
    path: '/',
    component: _import('main'),
    name: 'main',
    redirect: { name: 'home' },
    meta: { title: '主入口整体布局' },
    children: [
        // 通过meta对象设置路由展示方式
        // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
        // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
        // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
        { path: '/home', component: _import('common/home'), name: 'home', meta: { title: '首页' } }
    ],
    beforeEnter (to, from, next) {
      let token = sessionStorage.getItem("username");
      if (!token) {
        next({ name: 'login' })
      }
      next()
    }
};

const router = new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: globalRoutes.concat(mainRoutes)
});

router.beforeEach((to, from, next) => {
    // 添加动态(菜单)路由
    // 1. 已经添加 or 全局路由, 直接访问
    // 2. 获取菜单列表, 添加并保存本地存储
    if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
        next()
    } else {
      let username = sessionStorage.getItem("username");
      let param = { account: "admin" };
      info(param).then((res) => {
        if(res.data.code === 0){
          let data = res.data.info.roleList[0].permissions.sort(function(a,b){
            return a.id - b.id
          });
          let sysMenu = treeDataTranslate(data.filter(v => v.type !== 2));
          let perms = [];
          if(username !== "admin"){
            let para = { account : username};
            info(para).then((res) => {
              let data = res.data.info.roleList[0].permissions.sort(function(a,b){
                return a.id - b.id
              });
              data.filter(v => v.type === 2).forEach(function(v){
                perms.push(v.perms)
              });
              fnAddDynamicMenuRoutes(sysMenu);
              router.options.isAddDynamicMenuRoutes = true;
              sessionStorage.setItem('menuList', JSON.stringify(sysMenu || '[]'));
              sessionStorage.setItem('permissions', JSON.stringify(perms || '[]'));
              next({ name:'home'});
            }).catch((e) => {
              console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue');
              router.push({ name: 'login' })
            });
          }else {
            data.filter(v => v.type === 2).forEach(function(v){
              perms.push(v.perms)
            });
            fnAddDynamicMenuRoutes(sysMenu);
            router.options.isAddDynamicMenuRoutes = true;
            sessionStorage.setItem('menuList', JSON.stringify(sysMenu || '[]'));
            sessionStorage.setItem('permissions', JSON.stringify(perms || '[]'));
            next({ name:'home'});
          }
        }

      }).catch((e) => {
        console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue');
        router.push({ name: 'login' })
      });
    }
});

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route, globalRoutes = []) {
    let temp = [];
    for (let i = 0; i < globalRoutes.length; i++) {
        if (route.path === globalRoutes[i].path) {
            return 'global'
        } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
            temp = temp.concat(globalRoutes[i].children)
        }
    }
    return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
    var temp = [];
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].children && menuList[i].children.length >= 1) {
            temp = temp.concat(menuList[i].children)
        } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
            menuList[i].url = menuList[i].url.replace(/^\//, '');
            let route = {
                path: menuList[i].url.replace('/', '-'),
                component: null,
                name: menuList[i].url.replace('/', '-'),
                meta: {
                    id: menuList[i].id,
                    title: menuList[i].name,
                    isDynamic: true,
                    isTab: true,
                    iframeUrl: ''
                }
            };

            try {
                route['component'] = _import(`modules/${menuList[i].url}`) || null
            } catch (e) {

            }

            routes.push(route)
        }
    }
    if (temp.length >= 1) {
        fnAddDynamicMenuRoutes(temp, routes)
    } else {
        mainRoutes.name = 'main-dynamic';
        mainRoutes.children = routes;
        router.addRoutes([
            mainRoutes,
            { path: '*', redirect: { name: '404' } }
        ]);
        sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'));
        console.log('\n');
        console.log('%c!<-------------------- 动态(菜单)路由 s -------------------->', 'color:blue');
        console.log(mainRoutes.children);
        console.log('%c!<-------------------- 动态(菜单)路由 e -------------------->', 'color:blue')
    }
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js